
    var riot = require('riot')
    //src: starling/src/tags/perspective-settings-menu.html
riot.tag2('perspective-settings-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item" onmouseenter="{hideSubmenus}" onclick="{toggleShowAllPerspectives}"> <span class="floating-menu_label"> {areAllPerspectivesSelected() ? \'Hide all\' : \'Show all\'} </span> </li> <li ref="textLayoutOption" class="floating-menu_item" onclick="{openTextLayoutMenu}" onmouseenter="{openTextLayoutMenu}"> <span class="floating-menu_label">Perspective notes</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden floating-menu--fixed" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.perspectiveSettingsMenu = this;
this.top = 0;
this.left = 0;

this.show = function (_ref) {
  var spawnedFromElement = _ref.spawnedFromElement;

  if (spawnedFromElement) {
    var _spawnedFromElement$g = spawnedFromElement.getBoundingClientRect(),
        left = _spawnedFromElement$g.left,
        bottom = _spawnedFromElement$g.bottom;

    Object.assign(_this.root.style, {
      left: left + 'px',
      top: bottom + 4 + 'px'
    });
  }
  _this.summoned = true;
  _this.update();
  _this.root.classList.remove('floating-menu--hidden');
  _this.canvas.perspectivesListingTag.stickPerspectiveSettingsMenuButton();
};

this.hide = function () {
  if (_this.summoned) {
    _this.summoned = false;
    _this.root.classList.add('floating-menu--hidden');
    _this.hideSubmenus();
    _this.canvas.perspectivesListingTag.unstickPerspectiveSettingsMenuButton();
  }
};

this.hideSubmenus = function () {
  _this.canvas.perspectiveSettingsTextMenu.hide();
};

this.getStyle = function () {
  return 'top: ' + _this.top + 'px; left: ' + _this.left + 'px';
};

this.openTextLayoutMenu = function () {
  _this.canvas.perspectiveSettingsTextMenu.show({ spawnedFromElement: _this.refs.textLayoutOption });
};

this.areAllPerspectivesSelected = function () {
  return _perspectivesUi.pui.areAllPerspectivesSelected();
};

this.toggleShowAllPerspectives = function () {
  _perspectivesUi.pui.toggleShowAllPerspectives();
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspective-settings-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspective-settings-menu.html
// module id = 659
// module chunks = 0